import { NgModule, APP_INITIALIZER }           from '@angular/core';
import { CommonModule }       from '@angular/common';
import { FormsModule }        from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';
import { TranslateModule } from '@ngx-translate/core';

import { SeguimentTecnicComponent } from './seguiment-tecnic.component';
import { SeguimentTecnicListComponent } from './seguiment-tecnic-list/seguiment-tecnic-list.component';
import { SeguimentTecnicFiltersComponent } from './seguiment-tecnic-filtre/seguiment-tecnic-filtre.component';
import { ManageSeguimentTecnicComponent } from '../manage-seguiment-tecnic-projectes/manage-seguiment-tecnic.component';


import { SPListService } from './services/seguiment-tecnic.service';
import { SeguimentTecnicService } from '../services/seguiment-tecnic-service/seguiment-tecnic.service';

import { AngularMaterialModule } from '../angular-material.module';

export function appInitializerFactory(translate: TranslateService, languageService: LanguageService) {
  return () => languageService.initAndWait();
}

@NgModule({
  imports:      [
    CommonModule,
    FormsModule,
    AngularMaterialModule,
    TranslateModule
  ],
  declarations: [
    SeguimentTecnicComponent,
    SeguimentTecnicListComponent,
    SeguimentTecnicFiltersComponent,
    ManageSeguimentTecnicComponent
  ],
  exports:      [
    SeguimentTecnicComponent
  ],
  providers:    [ 
    SPListService, 
    SeguimentTecnicService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, LanguageService],
      multi: true
    } 
  ]
})
export class SeguimentTecnicModule { }
